import { apiClient } from './client';
import type { CfoAffiliationRead, CfoAffiliationsRead, CfoAffiliationReview, CfoFounderAddition } from './types';
const base = (slug: string, company: number) => `/projects/${encodeURIComponent(slug)}/cfo-workflow/companies/${company}/affiliations`;
export async function getAffiliations(slug: string, company: number, offset = 0): Promise<CfoAffiliationsRead> {
  return (await apiClient.get<CfoAffiliationsRead>(base(slug, company), { params: { offset, limit: 50 } })).data;
}
export async function reviewAffiliation(slug: string, company: number, id: string, request: CfoAffiliationReview): Promise<CfoAffiliationRead> {
  return (await apiClient.post<CfoAffiliationRead>(`${base(slug, company)}/${id}/review`, request)).data;
}
/** Add a founder no source listed: confirmed at once, signed by the reviewer. */
export async function addFounder(slug: string, company: number, request: CfoFounderAddition): Promise<CfoAffiliationRead> {
  return (await apiClient.post<CfoAffiliationRead>(base(slug, company), request)).data;
}
